import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { URLS } from '../../../shared/constants/urls.constant';
import {
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import { NavigationService } from '../../../navigation/navigation.service';

export const DIALOG_TYPE = 'card-payments-info';

@Component({
  selector: 'app-card-payments-info-dialog',
  templateUrl: './card-payments-info-dialog.component.html',
  styleUrls: ['./card-payments-info-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardPaymentsInfoDialogComponent implements OnInit {
  @Input() description: string;

  @Output() onConfirm: EventEmitter<void> = new EventEmitter<void>();
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();

  dialogType: string;
  underwritingStripeCanvasIcon: IIcon;
  trackingObject: ITrackingObject;
  trackingScreenName: TrackingScreenNamesEnum;

  constructor(private _navigationService: NavigationService) {}

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;
    this.underwritingStripeCanvasIcon = {
      name: 'underwriting-stripe-canvas',
      size: IconSizesEnum.custom,
    };
  }

  goToLearnMore() {
    this._navigationService.goToExternalUrl(URLS.PAYMENTS_HELP_CARDS, true);
  }
}
